import { render, staticRenderFns } from "./OHSEducationCreate.vue?vue&type=template&id=1216e8ff&"
import script from "./OHSEducationCreate.vue?vue&type=script&lang=js&"
export * from "./OHSEducationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports